import { Adapter as r } from "../../../../../../adapter.js";
import { TierConversionRuleModel as n } from "./tierConversionRule.model.js";
class s extends r {
  adapt(e) {
    return new n({
      balanceCap: e.balance_cap,
      minSourceUnits: e.min_source_units,
      targetUnits: e.target_units
    });
  }
  serialize(e) {
  }
}
export {
  s as TierConversionRuleAdapter
};
//# sourceMappingURL=tierConversionRule.adapter.js.map
